import React, { Component } from 'react';
import Config from './Config';
import List from './List';
import Modal from './Modal';
//import { Scrollbars } from 'react-custom-scrollbars';
import FX from './functions/functions';
//import OrderEdge from './OrderEdge';

class User extends Component {  constructor(props) {
  super(props);
    this.state = {users:[], activeUser: undefined, setPassword:false};
  }
  componentDidMount(){
    this.retrieveData();
  }
  retrieveData = (limit) => {
    var data = {customer_id: this.props.root.state.customer_id};
    console.log(data);
    console.log('--------------');
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'users' + qs, (res, i) => {
      console.log(res);
      this.setState({ users : res.users });
      this.props.root.loadNextPage =  this.retrieveData;
    });
  }
  componentWillMount(){
    var n = window.location.pathname.split('/');
    var x = [];
    for (var i = 0; i < n.length; i++){
      if(n[i]){
        x.push(n[i]);
      }
    }
    console.log(x);
    var found = false;
    if(x[1] && parseInt(x[1],10)){
        console.log(parseInt(x[1],10));
        var root_state = this.props.root.state;
        this.props.root.state.current_customer[x[0]].list.some(
        (ping) => {
          if(  parseInt(ping.id,10) ===  parseInt(x[1],10)){
            root_state.detail = ping;
            return found = true;
          }
          return false;
        }
        );
     }
      if (x[1] && !found) {
        this.retrieveDetail(parseInt(x[1],10));
      }
  }
  retrieveDetail = (id) => {
    console.log('pop');
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    var data = {customer_id:  this.props.root.state.customer_id};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'product_detail' + qs , (res, i) => {
      var detail = this.props.root.setState({detail: res.product});
      console.log(res);
    });
  }
  setPassword = (user) => {
    console.log(user);
    if(!this.state.setPassword){
        this.setState({setPassword:true, activeUser: user});
    }
    else {
        console.log('xxxxx');
        FX.load(this.props.root,'updatePassword' , (res, i) => {
           this.closeModal();
        }, {method:'POST',data:{user_login_id: this.state.activeUser.id, newPassword : document.getElementById('new_password').value}});
    }
  }
  setRoles = (user) => {
    console.log(user);
    if(!this.state.setRoles){
        this.setState({setRoles:true, activeUser: user});
    }
    else {
        console.log('xxxxx');
        FX.load(this.props.root,'updatePassword' , (res, i) => {
           this.closeModal();
        }, {method:'POST',data:{user_login_id: this.state.activeUser.id, newPassword : document.getElementById('new_password').value}});
    }
  }
  disableUser = (user, disable) => {
    console.log(user);
    var message;
    if(disable){
      message = "Prevent access the system for this user?";
    }
    else {
      message = "Allow access the system for this user?";
    }
    if(window.confirm(message)) {
        console.log('xxxxx');
        FX.load(this.props.root,'UserLogin/disable' , (res, i) => {
           this.retrieveData();
        }, {method:'POST',data:{user_login_id: user.id, disabled : disable}});
    }
  }
  isAdmin = () => {
    var user = this.props.root.state.user;
    return parseInt(user.admin_level, 10);
  }
  createUser = (user, disable) => {
    console.log(user);
    console.log(this.props.root.state.current_customer.email);
    if(!this.props.root.state.current_customer.email && !this.isAdmin()){
        alert('Please Contact Vdepot customer services.\nYour account needs a confirmed email address to add users.')
        return false;
    }
    if(!this.state.createUser){
        this.setState({createUser:true, activeUser: {email:'',forename:'', surname:'', customer_id:this.props.root.state.customer_id}});
    }
    else {
        console.log('xxxxx');
        FX.load(this.props.root,'createUser' , (res, i) => {
           this.closeModal();
            this.retrieveData();
        }, {method:'POST',data:{ user: this.state.activeUser}});
    }
  }
  deleteUser = (user) => {
    console.log(user);
  }
  closeModal = () => {
    this.setState({setPassword:undefined, setRoles:undefined, activeUser: undefined, createUser: undefined});
  }
  handle = (tgt, e) => {
      var request = tgt.split('.');
      console.log(request);
      if(request.length === 2 && request[0] == 'activeUser'){
          var activeUser = this.state.activeUser;
          activeUser[request[1]] = e.target.value;
          this.setState({activeUser: activeUser});
      }
  }
  render() {
    console.log(this.state);
      var modal;
      if(this.state.setPassword){
          modal = (
            <Modal title="Reset Password" close={this.closeModal}  buttons={[{text:'Cancel',action:this.closeModal},{text:'Update',action:this.setPassword}]}>
                <div className="password_interface">
                   <label>New Password</label> <input autocomplete="new-password"  id="new_password" type="password" />
                </div>
            </Modal>
          )
      }
      else if(this.state.setRoles){
          modal = (
            <Modal title="Set Roles" close={this.closeModal}  buttons={[{text:'Cancel',action:this.closeModal},{text:'Update',action:this.setPassword}]}>
                <div className="role_interface">
                   Account Admin
                   Control User Access
                </div>
            </Modal>
          )
      }
      else if(this.state.createUser){
          modal = (
            <Modal title="Create User" close={this.closeModal}  buttons={[{text:'Cancel',action:this.closeModal},{text:'Create User',action:this.createUser}]}>
                <div className="user_create_interface">
                   <div className="forename_cnt">
                        <label for="forename">Forename:</label>
                        <input id="forename" onChange={this.handle.bind(this,'activeUser.forename')} value={this.state.activeUser.forename} />
                   </div>
                   <div className="surname_cnt">
                        <label for="surname">Surname:</label>
                        <input id="surname" onChange={this.handle.bind(this,'activeUser.surname')} value={this.state.activeUser.surname} />
                   </div>
                   <div className="username_cnt">
                        <label for="username">Email Address:</label>
                        <input id="username" onChange={this.handle.bind(this,'activeUser.username')} value={this.state.activeUser.username} />
                   </div>
                   <div className="password_cnt">
                        <label for="password">Password:</label>
                        <input id="password" autocomplet="new-password" onChange={this.handle.bind(this,'activeUser.password')} value={this.state.activeUser.password} type="password" />
                   </div>
                </div>
            </Modal>
          )
      }
      var users = this.state.users.map((user) => {
          var disable;
          if(parseInt(user.status,10)) {
            disable = <button onClick={this.disableUser.bind(this,user,1)}>Disable User</button>;
          }
          else {
            disable = <button onClick={this.disableUser.bind(this,user,0)}>Enable User</button>;
          }
          return (
            <tr>
                <td>
                    {user.username}
                </td>
                <td>
                    {user.forename} {user.surname}
                </td>
                <td>
                    {user.email}
                </td>
                <td>
                   <button onClick={this.setPassword.bind(this,user)}>Set Password</button>
                </td>
                <td>
                   <button onClick={this.setRoles.bind(this,user)}>Set Roles</button>
                </td>
                <td>
                   {disable}
                </td>
            </tr>
         )
      });
      return (
        <div className="User">
          User
          {modal}
          <table>
            {users}
          </table>
          <button onClick={this.createUser}>Add User</button>
        </div>
      );
  }
}

export default User;



// WEBPACK FOOTER //
// ./src/User.js